import {ElementInputAutocomplete} from './element-input-autocomplete';

export class ElementInputMultiAutocomplete extends ElementInputAutocomplete {
  public constructor() {
    super();

    this.typeElement = 'multi-autocomplete';
  }
}
